module.exports = __webpack_public_path__ + "img/chinesecompany177.c380d56d.png";